import { render, staticRenderFns } from "./DisplayTaxo.vue?vue&type=template&id=62171e02"
import script from "./DisplayTaxo.vue?vue&type=script&lang=js"
export * from "./DisplayTaxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62171e02')) {
      api.createRecord('62171e02', component.options)
    } else {
      api.reload('62171e02', component.options)
    }
    module.hot.accept("./DisplayTaxo.vue?vue&type=template&id=62171e02", function () {
      api.rerender('62171e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/DisplayTaxo.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/DisplayTaxo.vue
// module id = 117
// module chunks = 0